module.exports = __webpack_public_path__ + "img/task_linked.1b1ced72.svg";